<template>
  <div v-if="initialized">
    <div v-if="service.agreementTemplate.data.long_desc">
      <div v-html="service.agreementTemplate.data.long_desc"></div>
    </div>
    <ModelForm
      ref="modelForm"
      :columns="service.quickCreateFormColumns"
      :onSubmitFunction="onSubmit"
      :record="record"
      formStyleType="default"
      :submitButtonLabel="updateRecord?.send_method === 'URL発行' ? '上記内容でURL発行' : '上記内容でおくる'"
      :disableConfirmBeforeSubmit="true"
      @update="
        ({ data }) => {
          updateRecord = data
        }
      "
    >
      <template #beforeActionButton>
        <span
          @click.prevent="() => openAgreementFlowPreviewModal()"
          class="btn btn-outline-secondary"
          ><ficon type="eye" /> プレビュー</span
        >
        <span
          @click.prevent="() => onSaveDraft()"
          class="btn btn-outline-secondary"
          ><ficon type="save" /> 下書き保存</span
        >
      </template>
    </ModelForm>
  </div>
</template>
<script lang="ts">
import { openAgreementFlowPreviewModalWithPsAgreementRequest } from '../AgreementFlowDefinitionInput/AgreementFlowDefinitionInputService'
import { ModelPsAgreementRequests } from '../FlowPages/flowTypes'
import { AgreementTemplateQuickCreateNewAgreementFormService } from './AgreementTemplateQuickCreateNewAgreementFormService'

export default {
  name: 'AgreementTemplateQuickCreateNewAgreementForm',
  props: {
    agreementTemplateId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      service: new AgreementTemplateQuickCreateNewAgreementFormService(
        this.agreementTemplateId,
      ),
      initialized: false,
      record: {} as Partial<ModelPsAgreementRequests>,
      updateRecord: {} as Partial<ModelPsAgreementRequests>,
    }
  },
  async mounted() {
    // @ts-ignore
    this.record.clinic_id = $core.$embAuth.user.ps_clinic?.id
    await this.service.initPromise
    this.initialized = true
  },
  methods: {
    async onSubmit(data: any) {
      try {
        const res = await this.service.createNewAgreement(data)
        if (!res) {
          this.$emit('canceled')
          return
        }
        this.$emit('submitted')
        return
      } catch (e) {
        console.error(e)
        this.$emit('submitError')
      } finally {
      }
    },
    openAgreementFlowPreviewModal() {
      // templateData と マージする必要がある
      const agreement_content = this.service.parseDataWithTemplateAgreementContent(
        this.updateRecord as any,
      )
      openAgreementFlowPreviewModalWithPsAgreementRequest(this.updateRecord, {
        ...this.service.agreementTemplate.data,
        agreement_content,
      })
    },
    /**
     * 下書き保存: ModelForm.save() と同様に errorCount で入力エラーをブロックし、
     * 問題なければ saveDraft（確認ダイアログ・upsert・トーストはサービス側）。
     */
    async onSaveDraft() {
      const modelForm = this.$refs.modelForm as any
      if (!modelForm) {
        return
      }
      if (modelForm.errorCount) {
        modelForm.isCheckValidate = true
        if (modelForm.scrollWhenValidationError) {
          modelForm.scrollToFirstValidateErrorElement()
        }
        return
      }
      try {
        const res = await this.service.saveDraft(this.updateRecord as any)
        if (!res) {
          return
        }
        this.$emit('submitted')
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>
